import { render, staticRenderFns } from "./DiaryBook.vue?vue&type=template&id=33bdf620&scoped=true"
import script from "./DiaryBook.vue?vue&type=script&lang=js"
export * from "./DiaryBook.vue?vue&type=script&lang=js"
import style0 from "./DiaryBook.vue?vue&type=style&index=0&id=33bdf620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bdf620",
  null
  
)

export default component.exports